export default __webpack_public_path__ + "static/cork-midsummer-c145ef5af256392bad2725a9ffa61ede.mp4";